const asset = (name) => `/generated/${name}.png`;

export const AUDIENCES = [
  {
    id: "homeowners",
    label: "Homeowners",
    body: "Enjoy a home cleaned to a professional standard.",
    image: asset("audience_homeowners"),
    icon: "home",
  },
  {
    id: "tenants",
    label: "Tenants Moving Out",
    body: "Leave your property in excellent condition.",
    image: asset("audience_tenants"),
    icon: "package",
  },
  {
    id: "landlords",
    label: "Landlords",
    body: "Prepare your unit for new tenants.",
    image: asset("audience_landlords"),
    icon: "key-round",
  },
  {
    id: "agents",
    label: "Property Agents",
    body: "Get your units viewing-ready faster.",
    image: asset("audience_agents"),
    icon: "briefcase",
  },
  {
    id: "designers",
    label: "Interior Designers",
    body: "Present your projects at their very best.",
    image: asset("audience_designers"),
    icon: "palette",
  },
  {
    id: "commercial",
    label: "Commercial Businesses",
    body: "Offices, retail, F&B and light commercial.",
    image: asset("audience_commercial"),
    icon: "building-2",
  },
];

/**
 * Figures an administrator can edit come from website settings; the other two
 * describe how the company operates and are not counts anyone maintains.
 *
 * A builder rather than a constant because a constant captures the bundled
 * defaults at import time — which is exactly how these ended up ignoring the
 * admin panel in the first place.
 */
export const buildTrustStats = (brand) => [
  { value: brand?.stats?.jobs ?? "5,000+", label: "Jobs Completed" },
  { value: `${brand?.stats?.rating ?? 4.9}★`, label: "Google Rating" },
  { value: "Insured", label: "Public Liability" },
  { value: "Islandwide", label: "Singapore Service" },
];

export const buildWhyUs = (brand) => [
  {
    icon: "users",
    title: "Experienced Professionals",
    body: "Trained cleaners using suitable equipment and techniques.",
  },
  {
    icon: "check-circle",
    title: `${brand?.stats?.jobs ?? "5,000+"} Completed Jobs`,
    body: "HDB, condos, landed homes and commercial properties.",
  },
  {
    icon: "star",
    title: `${brand?.stats?.rating ?? 4.9}-Star Google Rating`,
    body: "Trusted for workmanship, reliability and service.",
  },
  {
    icon: "shield-check",
    title: "Public Liability Coverage",
    body: "Confidence and protection during every project.",
  },
  {
    icon: "file-text",
    title: "Transparent Quotations",
    body: "Clear scope, no hidden charges.",
  },
  {
    icon: "smile",
    title: "Customer Satisfaction",
    body: "Every property treated carefully and professionally.",
  },
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Send Your Property Details",
    body: "Share photos and property info via WhatsApp.",
  },
  {
    step: "02",
    title: "Receive a Recommended Scope",
    body: "We'll advise the most suitable cleaning service.",
  },
  {
    step: "03",
    title: "Confirm Your Preferred Date",
    body: "Pick a slot that works for you.",
  },
  {
    step: "04",
    title: "Let Our Team Handle It",
    body: "We arrive on time and complete the job.",
  },
];
